/**
 * Created by Mohamed on 12/6/14.
 */

var mediaUtils = (typeof(window) == 'undefined')? require("./global/MediaUtils.js"): window.MediaUtils;
var docUtils = (typeof(window) == 'undefined')? require("./global/DocUtils.js"): window.DocUtils;
var globalFilters = (typeof(window) == 'undefined')? require("./global/globalFilters.js"): window.globalFilters;

/**
 * NunjucksWrapper takes a nunjucks instance and attaches common filters to it
 * This wrapper is used in both frontend and backend
 * @param nunjucks
 * @param utils
 * @constructor
 */
var NunjucksWrapper = function(nunjucks, utils) {
    var self = this;

    self.nunjucks = nunjucks;
    self.utils = utils;

    self.init = function() {

        mediaUtils.registerFilters(self.nunjucks);
        docUtils.registerFilters(self.nunjucks);

        self.nunjucks.addFilter('slugToState', function (slug, callback) {
          if (!slug) return "";
          return slug.replace(/\W/g, '');
        }, false);

        self.nunjucks.addFilter('jobUrl', globalFilters.jobUrl);

        self.nunjucks.addFilter('escapeDoubleCurlyBrackets', globalFilters['escapeDoubleCurlyBrackets']);
        self.nunjucks.addFilter('URLtoBackgroundImage', globalFilters['URLtoBackgroundImage']);

        /**
         * @module limitTo
         * url : https://gist.github.com/jbmoelker/9693778
         * Creates a new array or string containing only a specified number of elements.
         * The elements are taken from either the beginning or the end of the source array
         * or string, as specified by the value and sign (positive or negative) of limit.
         *
         * Same behavior as AngularJS limitTo filter: http://docs.angularjs.org/api/ng/filter/limitTo
         *
         * To use this filter in a template, first register it in the Nunjucks environment:
         *   env.addFilter('limitTo', limitTo);
         *
         * @example <caption>Limit to first 5 characters of string</caption>
         *   {{ "hello world" | limitTo(5) }}
         *   // outputs: hello
         *
         * @example <caption>Limit to last 5 characters of string</caption>
         *   {{ "hello world" | limitTo(-5) }}
         *   // outputs: world
         *
         * @example <caption>Limit to first 3 items in array</caption>
         *   {% set items = ["alpha","beta","charlie","delta","echo"] %}
         *   {% for item in items | limitTo(3) %} {{ loop.index }}.{{ item }} {% endfor %}
         *   // outputs: 1.alpha 2.beta  3.charlie
         *
         * @example <caption>Limit to last 3 items in array</caption>
         *   {% set items = ["alpha","beta","charlie","delta","echo"] %}
         *   {% for item in items | limitTo(-3) %} {{ loop.index }}.{{ item }} {% endfor %}
         *   // outputs: 1.charlie 2.delta 3.echo
         *
         * @param {String|Array} input  text or list of items to shorten
         * @param {Number} limit        either positive offset from start or negative offset from end
         */
        self.nunjucks.addFilter('limitTo', function (input, limit, truncateStr) {
          if (typeof limit !== 'number') {
            return input;
          }
          if (typeof input === 'string') {
              var suffix = truncateStr || "";

              if (input.length <= limit) {
                  suffix = "";
              }

            if (limit >= 0) {
              return input.substring(0, limit) + suffix;
            } else {
              return input.substr(limit);
            }
          }
          if (Array.isArray(input)) {
            limit = Math.min(limit, input.length);
            if (limit >= 0) {
              return input.slice(0, limit);
            } else {
              return input.slice(input.length + limit, input.length);
            }
          }
          return input;
        }, false);

        /**
         * [clear all empty index or undefined in array]
         * @param  {[element or objects]} array [array of elements to filter it]
         * @return {[array]}                    [new array with filtered elements]
         */
        self.nunjucks.addFilter('clearEmptyIndexInArray', function(array) {
            return array.filter(function(element){
                return !!element;
            });
        });

        self.nunjucks.addFilter('trusted', function(resouce) {
            return resouce;
        });

        self.nunjucks.addFilter('setAttribute', function(jsonObj, key, value) {
            jsonObj[key] = value;
            return jsonObj;
        });

        self.nunjucks.addFilter('hCurrency', function(amount, currencySymbol, fractionSize) {
            return Utils.hCurrency(amount, currencySymbol, fractionSize);
        });

        self.nunjucks.addFilter('compactNumber', function(number, currency) {
            return Utils.compactNumber(number, currency);
        });

        self.nunjucks.addFilter('userToBgColor', function(member, returnAsString) {
            return Utils.userToBgColor(member, returnAsString);
        });

        self.nunjucks.addFilter('stringToBackgroundColor', function (str) {
            return Utils.stringToBackgroundColor(str);
        });

        self.nunjucks.addFilter('firstChar', function(value) {
            return Utils.firstChar(value);
        });

        return self.nunjucks;
    }
}

if (typeof window !== 'undefined') {
    window.NunjucksWrapper = NunjucksWrapper;
}
// Export to backend
if (typeof module !== 'undefined') {
    module.exports = NunjucksWrapper;
}
